import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: '_.confirm_funding.header',
        defaultMessage: 'We’re all set to send funds to your account{tooltip}'
    },
    interestOnlyHeader: {
        id: '_.confirm_funding.interestOnlyHeader',
        defaultMessage: 'We are ready to extend your loan{tooltip}'
    },
    repaymentReductionHeader: {
        id: '_.confirm_funding.repayment_reduction_header',
        defaultMessage: 'We are ready to reduce your monthly repayments'
    },
    tooltip: {
        id: '_.confirm_funding.tooltip',
        defaultMessage:
            "You can adjust your choice by clicking 'Go back' below."
    },
    subHeader: {
        id: '_.confirm_funding.subheader',
        defaultMessage: 'Just hit ‘Confirm’ to send the funds to your account.'
    },
    interestOnlySubHeader: {
        id: '_.confirm_funding.interestOnlySubHeader',
        defaultMessage: 'Just hit ‘Confirm’ to extend your loan.'
    },
    repaymentReductionSubHeader: {
        id: '_.confirm_funding.repayment_reduction_subheader',
        defaultMessage:
            'Click on confirm to reduce your monthly repayments. We’re ready when you are!'
    },
    titleTopUp: {
        id: '_.confirm_funding.top_up.confirm.title',
        defaultMessage: 'Confirm withdrawal'
    },
    titleDrawDown: {
        id: '_.confirm_funding.title',
        defaultMessage: 'Confirm drawdown'
    },
    rblSubTitle: {
        id: '_.confirm_funding.rbl_subtitle',
        defaultMessage:
            "You're taking a Revenue Based Loan: you'll repay each month based on your revenue, and we'll take your payments straight from your account with Open Banking."
    },
    summaryTitleDrawDown: {
        id: '_.confirm_funding.summary_title',
        defaultMessage: 'You are requesting to borrow'
    },
    summaryTitleTopUp: {
        id: '_.confirm_funding.top_up.summary_title',
        defaultMessage: 'You are requesting to withdraw'
    },
    summaryTitleInterestOnly: {
        id: '_.confirm_funding.top_up.interestOnly_summary_title',
        defaultMessage: 'You are extending your interest-only period'
    },
    confirm: {
        id: '_.confirm_funding.confirm',
        defaultMessage: 'Confirm'
    },
    back: {
        id: '_.confirm_funding.back',
        defaultMessage: 'Back'
    },
    paidInTo: {
        id: '_.confirm_funding.paid_in_to',
        defaultMessage: 'Paid into'
    },
    repaidFrom: {
        id: '_.confirm_funding.repaid_from',
        defaultMessage: 'Repaid from'
    },
    summaryBreakdownDrawDown: {
        id: '_.confirm_funding.confirm_repayment.summary_breakdown',
        defaultMessage:
            'This will set your outstanding balance to {newBalance}.'
    },
    summaryBreakdownTopUp: {
        id: '_.confirm_funding.top_up.confirm_repayment.summary_breakdown',
        defaultMessage:
            'This will increase your outstanding balance to {newBalance}.'
    },
    repaymentBreakdown: {
        id: '_.confirm_funding.repayment_breakdown',
        defaultMessage: 'See full repayment schedule'
    },
    repaymentFromExplanation: {
        id: '_.confirm_funding.repayment_from_explanation',
        defaultMessage: 'Repayment from explanation'
    }
});
